import React from 'react';
import { Badge, BlockStack, Card, InlineStack, Text } from '@shopify/polaris';
import { IBundleApp } from './config';
import AppChip from './AppChip';
import PlanGrid from './PlanGrid';
import { StyledAppToggle } from './styled';

interface IAppCardProps {
  app: IBundleApp;
  selectedPlanId: string;
  included: boolean;
  onChange: (planId: string) => void;
  onToggle: () => void;
  isLoading?: boolean;
}

const AppCard = ({ app, selectedPlanId, included, onChange, onToggle, isLoading }: IAppCardProps) => (
  <Card>
    <div style={{ position: 'relative' }}>
      <StyledAppToggle style={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}>
        <input type="checkbox" checked={included} onChange={onToggle} />
        <Text variant="bodySm" tone="subdued" as="span">
          {included ? 'Included' : 'Not included'}
        </Text>
      </StyledAppToggle>
      <BlockStack gap="300">
        <div style={{ paddingRight: 110 }}>
          <InlineStack gap="200" blockAlign="center" wrap={false}>
            <AppChip color={app.color} letter={app.letter} label={app.name} logo={app.logo} size={32} />
            <BlockStack gap="025">
              <InlineStack gap="150" blockAlign="center">
                <Text variant="headingLg" as="h3">
                  {app.name}
                </Text>
                {app.isInstalled && (
                  <Badge tone="info" progress="complete">
                    Installed
                  </Badge>
                )}
              </InlineStack>
              <Text variant="bodySm" tone="subdued" as="span">
                {app.desc}
              </Text>
            </BlockStack>
          </InlineStack>
        </div>
        {included ? (
          <PlanGrid app={app} selectedPlanId={selectedPlanId} onChange={onChange} isLoading={isLoading} />
        ) : (
          <Card background="bg-surface-secondary">
            <Text variant="bodySm" tone="subdued" as="span">
              Check &quot;Included&quot; above to add {app.name} to your stack.
            </Text>
          </Card>
        )}
      </BlockStack>
    </div>
  </Card>
);

export default AppCard;
